import React from 'react';
import { useConnect } from '@lore/query-connect';
import PROJECT_REQUIRED_FIELDS from '../../projects/REQUIRED_FIELDS';
import EVENT_REQUIRED_FIELDS from '../../events/REQUIRED_FIELDS';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../ComparisonMetric';

export default function AssociatedWithProjectOrEvent(props) {
  const { network, schoolStart, schoolEnd, titleOnly } = props;

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousSchools = useConnect('site.find', {
    where: {
      eager: {
        $where: {
          $or: [
            {
              projects: {
                $where: {
                  $and: PROJECT_REQUIRED_FIELDS.$and,
                  // 'creator.isEducator': true,
                  networkId: network?.id,
                  createdAt: {
                    $lte: schoolStart,
                    // $gte: titleOnly ? undefined : previousSchoolStart
                    // $lte: schoolEnd
                  }
                },
                $having: {
                  count: {
                    $gte: 1
                  }
                }
              }
            },
            {
              events: {
                $where: {
                  $and: EVENT_REQUIRED_FIELDS.$and,
                  // 'creator.isEducator': true,
                  networkId: network?.id,
                  createdAt: {
                    $lte: schoolStart,
                    // $gte: titleOnly ? undefined : previousSchoolStart
                    // $lte: schoolEnd
                  }
                },
                $having: {
                  count: {
                    $gte: 1
                  }
                }
              }
            }
          ]
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const allSchools = useConnect('site.find', {
    where: {
      eager: {
        $where: {
          $or: [
            {
              projects: {
                $where: {
                  $and: PROJECT_REQUIRED_FIELDS.$and,
                  // 'creator.isEducator': true,
                  networkId: network?.id,
                  createdAt: {
                    $lte: schoolEnd,
                    // $gte: schoolStart
                  }
                },
                $having: {
                  count: {
                    $gte: 1
                  }
                }
              }
            },
            {
              events: {
                $where: {
                  $and: EVENT_REQUIRED_FIELDS.$and,
                  // 'creator.isEducator': true,
                  networkId: network?.id,
                  createdAt: {
                    $lte: schoolEnd,
                    // $gte: schoolStart
                  }
                },
                $having: {
                  count: {
                    $gte: 1
                  }
                }
              }
            }
          ]
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  if (
    previousSchools.state === PayloadStates.FETCHING ||
    allSchools.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name="Engaged with Project or Event"
      />
    );
  }

  return (
    <ComparisonMetric
      name="Engaged with Project or Event"
      value={allSchools.meta.totalCount}
      previousValue={previousSchools.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
